import React, { useState } from 'react'
import { generateSymbolColors } from '../../../components/chartColor';
import Chart from 'react-apexcharts'
import BlurredText from '../../../components/BlurText';
import Layout from '../../layout/Layout';
import { useTheme } from "../../../utils/theme";
const userMultibaggerList = {
    dataList: [
        {
            id: 1,
            symbol: "TATASTEEL",
            qty: 150,
            invested: 187500,
            currentVal: 214350,
            recomPrice: 1250,
            ltp: 1429,
            todayPLVal: 3250.75,
            todayPLPer: 1.54,
            overallPLVal: 26850.75,
            overallPLPer: 14.32,
            multibaggerReportPath: "https://example.com/reports/tatasteel.pdf",
            bookedAt: null
        },
        {
            id: 2,
            symbol: "INFY",
            qty: 50,
            invested: 72500,
            currentVal: 68900,
            recomPrice: 1450,
            ltp: 1378,
            todayPLVal: -950.25,
            todayPLPer: -1.36,
            overallPLVal: -3600,
            overallPLPer: -4.96,
            multibaggerReportPath: "https://example.com/reports/infy.pdf",
            bookedAt: null
        },
        {
            id: 3,
            symbol: "HDFCBANK",
            qty: 80,
            invested: 132000,
            currentVal: 158400,
            recomPrice: 1650,
            ltp: 1980,
            todayPLVal: 1840,
            todayPLPer: 1.18,
            overallPLVal: 26400,
            overallPLPer: 20.00,
            multibaggerReportPath: "https://example.com/reports/hdfcbank.pdf",
            bookedAt: null
        }
    ],
    meta: {
        currentValue: 441650,
        invested: 392000,

        overallPLAmt: 49650,
        overallPLPer: 12.67,

        todayGainAmt: 4140.5,
        todayGainPer: 0.95,
    },
};
const blurLegends = () => {
    const legends = document.querySelectorAll(".apexcharts-legend-text");
    legends.forEach((el) => {
        el.textContent = "xxxxxxxx"
        el.style.filter = "blur(4px)";
        el.style.userSelect = "none";
    });
};
const MultibaggerModel = () => {
    const { theme } = useTheme();
    const symbols = userMultibaggerList?.dataList?.map(item => item.symbol) || [];
    const symbolColors = generateSymbolColors(symbols);
    const [selectedStockId, setSelectedStockId] = useState(null);
    const chartData = {
        series: [
            userMultibaggerList.meta.invested,
            userMultibaggerList.meta.overallPLAmt,
        ],
        options: {
            chart: {
                type: "donut",
                events: {
                    mounted: () => {
                        blurLegends();
                    },
                    updated: () => {
                        blurLegends();
                    }
                }
            },
            labels: ["Invested", "Profit"],
            legend: {
                position: "right",
                labels: {
                    colors: theme === "dark" ? "#e5e7eb" : "#374151",
                },
            },
            dataLabels: {
                enabled: false,
            },
            tooltip: {
                y: {
                    formatter: (val) =>
                        `₹${Number(val).toLocaleString("en-IN")}`,
                },
            },
            plotOptions: {
                pie: {
                    donut: {
                        size: "70%",
                        labels: {
                            show: true,
                            name: {
                                color: theme === "dark" ? "#f8fafc" : "#111827",
                            },
                            value: {
                                color: theme === "dark" ? "#f8fafc" : "#111827",
                            },
                            total: {
                                color: theme === "dark" ? "#f8fafc" : "#111827",
                            },
                        },
                    },
                },
            },
        },
    };

    const formatNumber = (num) => {
        return Number(num || 0).toLocaleString("en-IN", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        });
    };
    return (
        <Layout>



            <div className="py-3">
                <div className="container">


                    <div className="row g-3 align-items-center">
                        {/* ===== LEFT : 6 parts (Calculations) ===== */}

                        <div className="col-md-8 d-none">
                            <div className="row g-3">
                                <div className="col-12 ">
                                    <a href="/dashboard" class="text-decoration-none text-body-emphasis fs-5"><i class="fa fa-arrow-left"></i></a>
                                    <div className='d-flex align-items-baseline gap-2'>

                                        <h4 className="mb-0 fw-bold">Multibaggers</h4>

                                    </div>
                                    <p className='text-muted'>EP Multibaggers <small className="fw-normal text-muted ">(
                                        {3} {" "}
                                        Stocks)</small></p>
                                </div>
                                <div className="col-12">
                                    <button className='btn btn-dark' type="button" onClick={() => {
                                        window.open("https://equitypandit.in/services/multibagger", "_blank");
                                    }}>
                                        <div className='d-flex gap-2 justify-content-center align-items-center'>

                                            <i class="fa fa-lock" aria-hidden="true"></i>
                                            <span>View Full Portfolio</span>
                                        </div>
                                    </button>
                                </div>
                                <div className="col-6">
                                    <small className="text-muted">Allocated Fund</small>
                                    <h5 className="fw-semibold">
                                        ₹2,00,000
                                    </h5>
                                </div>

                                <div className="col-6">
                                    <small className="text-muted">Utilized (98%)</small>
                                    <h5 className="fw-semibold">
                                        ₹1,98,000
                                    </h5>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-12">
                            <a href="/dashboard" class="text-decoration-none text-body-emphasis fs-5"><i class="fa fa-arrow-left"></i></a>
                        </div>
                        <div class="col-md-8">
                            <div class="mb-3">
                                <h4 class="mb-0 fw-bold">Multibaggers</h4>
                                <small class="fw-normal text-muted">EP Multibaggers</small>
                            </div>

                            <p>
                                Subscribe To Multibagger Package to View recommended Multibagger Stocks
                            </p>
                            <div class="row g-3 align-items-center d-none">
                                <div class="col-md-3 col-6">
                                    <small class="text-muted d-block">Allocated Fund</small>
                                    <h4 class="mb-0">2,00,000</h4>
                                </div>
                                <div class="col-md-3 col-6">
                                    <small class="text-muted d-block">Utilized <small class="text-muted">(98%)</small></small>
                                    <h4 class="mb-0">1,98,000</h4>
                                </div>
                                {/* <!-- <div class="col-md-3 col-6">
                                    <small class="text-muted d-block">Available Funds</small>
                                    <h4 class="mb-0">25,000</h4>
                                </div> -->
                                <!-- <div class="col-md-3 col-6">
                                    <small class="text-muted d-block">Current Value</small>
                                    <h4 class="mb-0">1,80,000</h4>
                                </div>
                                <div class="col-md-3 col-6">
                                    <small class="text-muted d-block">Overall P&L</small>
                                    <div class="d-flex align-items-baseline gap-2">
                                        <h4 class="text-success mb-0">+5,000</h4>
                                        <small class="text-success">(+7.5%)</small>
                                    </div>
                                </div>
                                <div class="col-md-3 col-6">
                                    <small class="text-muted d-block">Day's P&L</small>
                                    <div class="d-flex align-items-baseline gap-2">
                                        <h4 class="text-success mb-0">+500</h4>
                                        <small class="text-success">(+0.75%)</small>
                                    </div>
                                </div> --> */}
                            </div>
                            <button class="btn btn-dark" onClick={() => { window.open("https://equitypandit.in/services/multibagger", "_blank"); localStorage.removeItem("selectedPortfolio"); }}>Subscribe Now</button>

                        </div>
                        <div className="col-md-4 d-none">
                            <div className="mt-3">
                                <Chart
                                    options={chartData.options}
                                    series={chartData.series}
                                    type="donut"
                                    // height={1050}
                                    width={350}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="p-3 rounded-3 bg-dark text-light d-none">
                        <div className="row g-3 small">
                            <div className="col-md-3">Scrip</div>
                            <div className="col-md-3 text-end"></div>
                            <div className="col-md-3 text-end">Invested & Current Val.</div>
                            <div className="col-md-3 text-end">Avg. Price & CMP</div>
                            {/* <div className="col-md-2 text-end">1 Day P&L</div> */}
                            {/* <div className="col-md-2 text-end">Total P&L</div> */}

                        </div>
                    </div>
                    {userMultibaggerList?.dataList?.length > 0 && userMultibaggerList?.dataList?.bookedAt == null ? (
                        userMultibaggerList.dataList.map((stock, idx) => (
                            <div
                                key={idx}
                                className="p-3 rounded-3 d-none bg-light text-dark my-2"
                            >
                                <div className="row g-2 align-items-center">

                                    {/* Scrip */}
                                    <div className="col-md-3 col-12">
                                        <div className="d-flex align-items-center gap-2">
                                            <BlurredText blur={4}>
                                                <i
                                                    className="fa fa-circle"
                                                    style={{
                                                        color: symbolColors[stock.symbol],
                                                        fontSize: "10px",
                                                    }}
                                                ></i>
                                            </BlurredText>
                                            <BlurredText blur={4}>
                                                {"xxxxxxx"}
                                            </BlurredText>
                                        </div>
                                        <small className="d-block">
                                            <small className="text-muted d-block">
                                                <i className="fas fa-briefcase"></i> {stock.qty?.toLocaleString("en-IN")}
                                            </small>
                                        </small>
                                    </div>


                                    <div className="col-md-3 col-12">
                                        <div className="mt-1 d-flex justify-content-md-center gap-2 align-items-center" style={{ cursor: "pointer" }}>
                                            <i
                                                className="fa fa-file text-primary"
                                                style={{ fontSize: "12px" }}
                                            ></i>

                                            <span
                                                className="text-primary uni-cursor-pointer small"
                                            // onClick={() => setSelectedStockId(stock.id)}
                                            >
                                                View Report
                                            </span>
                                        </div>
                                    </div>

                                    <div className="col-md-3 col-6 text-md-end">
                                        <small className="d-md-none text-muted">Invested & Current Val</small>
                                        <div>
                                            {Number(stock?.invested).toFixed(2)}
                                        </div>


                                        {/* <div
                                            className={
                                                Number(stock?.currentVal) >= Number(stock?.invested)
                                                    ? "text-success "
                                                    : "text-danger "
                                            }
                                        >
                                            {Number(stock?.currentVal).toFixed(2)}
                                        </div> */}
                                    </div>
                                    {/* Recom Date */}
                                    {/* <div className="col-md-1 col-6 text-md-end">
                        <small className="d-md-none text-muted">Recom Date</small>
                        {moment(stock.recomandedDate).format("D MMM YYYY")}
                      </div> */}

                                    {/* Recom Price */}
                                    <div className="col-md-3 col-6 text-md-end">
                                        <small className="d-md-none text-muted">CMP</small>
                                        <div>
                                            {formatNumber(stock.recomPrice.toFixed(2))}
                                        </div>
                                        {/* <div
                                            className={
                                                Number(stock?.ltp) >= Number(stock?.recomPrice)
                                                    ? "text-success "
                                                    : "text-danger "
                                            }
                                        >
                                            {Number(stock?.ltp).toFixed(2)}
                                        </div> */}
                                    </div>

                                    {/* LTP */}
                                    {/* <div className="col-md-2 col-6 text-md-end">
                                        <small className="d-md-none text-muted">1 Day P&L</small>
                                        <div>
                                            <span className={`${stock.todayPLVal >= 0 ? "text-success" : "text-danger"}`}>{stock.todayPLVal != null
                                                ? Number(stock.todayPLVal).toLocaleString("en-IN", {
                                                    minimumFractionDigits: 2,
                                                    maximumFractionDigits: 2,
                                                })
                                                : "--"}<br className="d-none d-md-block" />
                                                <small><small className={`${stock?.todayPLPer >= 0 ? "text-success" : "text-danger"}`}>(
                                                    {stock.todayPLPer != null
                                                        ? Number(stock.todayPLPer).toFixed(2)
                                                        : "--"}
                                                    %) <i className={stock?.todayPLPer >= 0 ? "fa fa-caret-up" : "fa fa-caret-down"}></i></small></small>
                                            </span>
                                        </div>
                                    </div> */}

                                    {/* Qty */}
                                    {/* <div className="col-md-2 col-6 text-md-end">
                                        <small className="d-md-none text-muted">Total P&L</small>
                                        <div>
                                            <span className={`${stock.overallPLVal >= 0 ? "text-success" : "text-danger"}`}>{stock.overallPLVal != null
                                                ? Number(stock.overallPLVal).toLocaleString("en-IN", {
                                                    minimumFractionDigits: 2,
                                                    maximumFractionDigits: 2,
                                                })
                                                : "--"}<br className="d-none d-md-block" />
                                                <small><small className={`${stock?.overallPLPer >= 0 ? "text-success" : "text-danger"}`}>(
                                                    {stock.overallPLPer != null
                                                        ? Number(stock.overallPLPer).toFixed(2)
                                                        : "--"}
                                                    %) <i className={stock?.overallPLPer >= 0 ? "fa fa-caret-up" : "fa fa-caret-down"}></i></small></small>
                                            </span>
                                        </div>
                                    </div> */}



                                </div>

                                {/* Modal */}
                                {selectedStockId === stock.id && (
                                    <div className="modal fade show d-block" tabIndex="-1">
                                        <div className="modal-dialog modal-xl modal-dialog-centered">
                                            <div className="modal-content">
                                                <div className="modal-header">
                                                    <h5 className="modal-title">{stock.symbol} Report</h5>
                                                    <button
                                                        className="btn-close"
                                                        onClick={() => setSelectedStockId(null)}
                                                    ></button>
                                                </div>
                                                <div className="modal-body" style={{ height: "80vh" }}>
                                                    <iframe
                                                        src={`${stock.multibaggerReportPath}#toolbar=0`}
                                                        style={{ width: "100%", height: "100%", border: 0 }}
                                                        title={stock.symbol}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        ))
                    ) : (
                        <div className="text-center text-muted py-4">
                            Data not found
                        </div>
                    )}
                </div>
            </div>
        </Layout>
    )
}

export default MultibaggerModel
